import { size, get } from "lodash"

export function getRedirectUrl(user, url) {
  if (user.isSuperuser && !url) {
    return "/admin"
  }

  if (user.forceLinkAccount) {
    return "/link-account"
  }

  if (url) {
    return url
  }

  if (!size(user.accounts) && !size(user.partners)) {
    return "/contact-admin"
  }
  if (size(user.accounts) === 1 && !size(user.partners)) {
    return `/${get(user, "accounts.0.alias")}`
  }
  if (!size(user.accounts) && size(user.partners) === 1) {
    return `/partners/${get(user, "partners.0.alias")}`
  }

  return "/accounts"
}
